import { render } from "./QuranSajdaList.vue?vue&type=template&id=6a37cb08"
import script from "./QuranSajdaList.vue?vue&type=script&lang=js"
export * from "./QuranSajdaList.vue?vue&type=script&lang=js"
script.render = render

export default script